import axios from "axios";
import { localStorageKeys } from "../../config/localStorageKeys";

export const basicClient = axios.create();

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

export const apiFGTS = axios.create({
  baseURL: import.meta.env.VITE_API_FGTS_URL,
});

export const reportApi = axios.create({
  baseURL: import.meta.env.VITE_API_REPORTS_URL || import.meta.env.VITE_API_URL,
});

httpClient.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

apiFGTS.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

reportApi.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});
